module.exports = __webpack_public_path__ + "img/a-propos.8afe6efe.jpg";